<template>
  <div>
    <div>
      <tooltip placement="top" class="full-width" :disabled="breakpoints().sm">
        <template #trigger>
          <SlotWrapper>
            <template #target>
              <span
                v-if="soldWarranty && soldWarranty.warranty_program_name"
                class="link"
                @click="toggleWarrantyModal"
                >{{ soldWarranty.warranty_program_name }}</span
              >
              <span v-else> -- </span>
            </template>
          </SlotWrapper>
        </template>
        <template #tooltip>
          Invoice #{{ invoice.invoice_id }} Equipment - Qty #{{
            workItem.unit_number
          }}
          of {{ lineItem.quantity }}
        </template>
      </tooltip>
    </div>
    <EquipmentWarrantyLinkModal
      v-if="showEquipmentWarrantyLinkModal"
      v-bind="$props"
      @hide-modal="toggleWarrantyModal"
      @save-and-complete="refreshDataTable"
      @ignore="refreshDataTable"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import SlotWrapper from "@/components/SlotWrapper";
import EquipmentWarrantyLinkModal from "@/Equipment/EquipmentWarrantyLinkModal.vue";

export default {
  components: {
    SlotWrapper,
    EquipmentWarrantyLinkModal
  },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    soldWarranty: {
      type: Object,
      default: () => {}
    },
    workItem: {
      type: Object,
      default: () => {}
    },
    lineItem: {
      type: Object,
      default: () => {}
    },
    effectiveAfterDays: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showEquipmentWarrantyLinkModal: false
    };
  },
  methods: {
    refreshDataTable() {
      EventBus.$emit("refresh-datatable");
    },
    toggleWarrantyModal() {
      this.showEquipmentWarrantyLinkModal =
        !this.showEquipmentWarrantyLinkModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
